import { render, staticRenderFns } from "./RangesRecommendation.vue?vue&type=template&id=743dd310"
import script from "./RangesRecommendation.vue?vue&type=script&lang=js"
export * from "./RangesRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports